import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ModalController } from "ionic-angular";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";
import { IntercardDataService } from "../intercard-data/intercard-data.service";

/**
 * Generated class for the QuestionsCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "questions-card",
  templateUrl: "questions-card.html",
})
export class QuestionsCardComponent implements OnInit {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;
  @Output() onDataUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onCardInitialized: EventEmitter<any> = new EventEmitter();

  id: string;
  label: string;
  componentId: string;
  access: string;
  displayHeaderCount: boolean = false;
  subheaderDescription: string;
  declinable: boolean;
  supportOther: boolean = false;
  otherId: string = "questionCardOther";
  incomingData: any;

  baseRows: string[] = []; // Rows loaded from the configuration
  rows: string[] = []; // Current state of the rows (for 'other' support)
  totalRows: number;
  rowsAnswered: number = 0;

  reportableRows: string[] = [];
  reportableAnswers: string[] = [];

  questions: object[] = [];
  answers: object = {};

  initialized: boolean = false;

  noopCallback: Function = function () {};

  constructor(
    public modalCtrl: ModalController,
    public translatePipe: TranslateService,
    public dataService: AssessmentDataService,
    public intercard: IntercardDataService
  ) {
    // console.log('Hello QuestionsCardComponent Component');
  }

  ngOnInit(): void {
    // console.log( "Incoming configuration for question card: ", this.config );

    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label = this.config.cardName;
    this.access = this.config.access;
    if (this.config.displayHeaderCount) {
      this.displayHeaderCount = true;
    }
    this.subheaderDescription = this.config.subheaderDescription;
    this.declinable = this.config.declinable;
    if (this.config.supportOther) {
      this.supportOther = true;
    }

    this.baseRows = this.config.rows;
    this.rows = JSON.parse(JSON.stringify(this.baseRows)); // Copy by value instead of reference
    if (this.supportOther) {
      if (this.rows["other"] === undefined || this.rows["other"] === null) {
        this.rows.push("other");
      }
    }
    this.totalRows = this.rows.length;
    if (this.config.reportableRows) {
      this.reportableRows = this.config.reportableRows;
    }
    if (this.config.reportableAnswers) {
      this.reportableAnswers = this.config.reportableAnswers;
    }

    this.questions = this.config.questions;

    for (let question of this.questions) {
      if (question["inputs"]) {
        let inputs = question["inputs"];
        for (let key of Object.keys(inputs)) {
          inputs[key]["id"] = key;
        }
      }
    }
  }

  @Input() set data(incomingData: any) {
    // console.log( "Form card Data: ", this.data );
    // console.log( "Form card Incoming data: ", incomingData );
    if (incomingData) {
      // console.log( "Loaded data for questions card: ", data );

      let cardData = incomingData;
      this.incomingData = cardData;
      if (cardData.data) {
        this.answers = cardData.data[0]["answers"];
        this.rowsAnswered = Object.keys(this.answers).length;
      }
      this.pushData();

      if (this.supportOther) {
        for (let key of Object.keys(this.answers)) {
          if (key !== "other") {
            let baseRows = this.baseRows;
            if (baseRows.indexOf(key) == -1) {
              this.rows.splice(this.rows.length - 1, 0, key);
            }
          }
        }
        this.totalRows = this.rows.length;
      }
    }

    if (incomingData !== undefined && !this.initialized) {
      // console.log( "Flagging questions card as initialized.", this.id );
      this.initialized = true;
      this.onCardInitialized.emit(this.id);
    }
  }

  optionSelected(row, answerId) {
    // console.log( "Option clicked: ", row, answerId );

    if (this.access === "read") {
      return;
    }

    this.answers[row] = { answer: answerId };
    this.rowsAnswered = Object.keys(this.answers).length;

    if (row !== "other") {
      for (let question of this.questions) {
        if (question["id"] == answerId) {
          if (question["inputs"]) {
            break;
          } else {
            this.pushData();
            return;
          }
        }
      }
    }

    let header =
      this.translatePipe.instant("addNotes") +
      " - " +
      this.translatePipe.instant(row);
    let callback = (data) => {
      // console.log( "GOT DATA BACK!:" );
      // console.log(data);

      if (data !== undefined) {
        // console.log( "Data returned from questions modal: ", data );
        if (row == "other") {
          let newRow = data[this.otherId];
          delete data[this.otherId];

          this.rows.splice(this.rows.length - 1, 0, newRow);
          this.totalRows = this.rows.length;
          this.answers[newRow] = { answer: answerId };
          if (Object.keys(data).length > 0) {
            this.answers[newRow]["additionalData"] = data;
          }

          delete this.answers["other"];
        } else {
          this.answers[row]["additionalData"] = data;
        }
        this.pushData();

        if (
          this.reportableRows.indexOf(row) > -1 &&
          this.reportableAnswers.indexOf(answerId) > -1
        ) {
          this.intercard.emitData("reportableIssues", { issueType: row });
        }
      } else {
        this.answers[row] = this.incomingData
          ? this.incomingData.data[0]["answers"]["row"] || null
          : null;
        // this.answers[row] = this.answers[row] || null;
        if (row === "other") {
          this.answers[row] = null;
        }
      }
    };

    this.presentInputModal(row, false, null, header, callback);
  }

  launchReadOnly(row) {
    // console.log( "Launching read only: ", row );
    if (!this.answers[row] || !this.answers[row]["additionalData"]) {
      return;
    }

    let existingData = this.answers[row]["additionalData"];
    let header =
      this.translatePipe.instant("viewNotes") +
      " - " +
      this.translatePipe.instant(row);

    this.presentInputModal(row, true, existingData, header, this.noopCallback);
  }

  launchEdit(row) {
    // console.log( "Launching edit: ", row );
    if (!this.answers[row] || !this.answers[row]["additionalData"]) {
      return;
    }

    let existingData = this.answers[row]["additionalData"];
    let header =
      this.translatePipe.instant("editNotes") +
      " - " +
      this.translatePipe.instant(row);
    let callback = (data) => {
      // console.log( "GOT DATA BACK!:" );
      // console.log(data);

      if (data !== undefined) {
        // console.log( "Data returned from questions modal: ", data );
        this.answers[row]["additionalData"] = data;
        this.pushData();
      }
    };

    this.presentInputModal(row, false, existingData, header, callback);
  }

  presentInputModal(
    row: string,
    readonly: boolean,
    existingData: object,
    header: string,
    callback: Function
  ) {
    let answerId = this.answers[row]["answer"];
    let modalConfig = {};

    let questionConfig;
    for (let question of this.questions) {
      if (question["id"] === answerId) {
        questionConfig = question;
        break;
      }
    }

    if (answerId === "yes") {
      modalConfig["id"] = header;
      modalConfig["cardName"] = this.translatePipe.instant(row);
      if (readonly) {
        modalConfig["readonly"] = true;
      }
      if (questionConfig.inputs || row == "other") {
        if (questionConfig.inputs) {
          modalConfig["inputs"] = JSON.parse(
            JSON.stringify(questionConfig.inputs)
          );
        }

        if (row == "other") {
          let input = {
            id: this.otherId,
            componentId: this.otherId,
            type: "text",
            rules: {
              required: true,
            },
          };

          let inputs = {};
          inputs[this.otherId] = input;
          if (modalConfig["inputs"]) {
            for (let key of Object.keys(modalConfig["inputs"])) {
              inputs[key] = modalConfig["inputs"][key];
            }
          }

          modalConfig["inputs"] = inputs;
          // console.log( "modalConfig inputs: ", modalConfig['inputs'] );
        }
      }
      if (questionConfig.dependencies) {
        modalConfig["dependencies"] = JSON.parse(
          JSON.stringify(questionConfig.dependencies)
        );
      }
      if (questionConfig.layout) {
        modalConfig["layout"] = JSON.parse(
          JSON.stringify(questionConfig.layout)
        );
        if (row == "other") {
          modalConfig["layout"][0]["rows"].unshift({ id: "questionCardOther" });
        }
      }

      let launchData = { config: modalConfig };
      if (existingData) {
        launchData["data"] = existingData;
      }

      let listModal = this.modalCtrl.create("InputModalPage", launchData, {
        enableBackdropDismiss: false,
      });
      if (callback) {
        listModal.onDidDismiss((data) => {
          callback(data);
        });
      }
      listModal.present();
    }
  }

  pushData() {
    this.onDataUpdate.emit({
      cardId: this.id,
      value: { answers: this.answers },
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/questions-card/questions-card.ts